/* global analytics */

import React, { Component } from 'react';
import WelcomeForm from "../components/WelcomeForm";

export default class Welcome extends Component {

    onLogin(email, password) {
        this.props.onLogin(email, password);
    }

    onRegister(email, password, firstName) {
        this.props.onRegister(email, password, firstName);
    }

    componentWillMount() {
        if(process.env.NODE_ENV === 'production') analytics.page("Welcome");
        //window.Intercom("update");
    }

    render() {
        let style = {
            intro: {
                position: 'fixed',
                top: 100,
                left: 0,
                right: 0,
                textAlign: 'center',
                margin: '0 auto',
            },
            disclaimer: {
                position: 'fixed',
                bottom: 40,
                left: 0,
                right: 0,
                textAlign: 'center',
                color: '#BBB',
                fontSize: 14,
            },
            h1: {
                fontFamily: 'Merriweather',
                marginBottom: 20,
                fontSize: 24,
                fontWeight: 600,
                color: '#414255'
            },
            p: {
                opacity: 0.8,
            },
            label: {
                border: '1px solid #38B08C',
                padding: '4px 8px 5px 9px',
                borderRadius: 4,
                color: '#38B08C',
                marginLeft: 6,
                fontSize: 12,
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: 1,
            }
        };

        return (
            <div>
                <div style={style.intro}>
                    <h1 style={style.h1}>Moneylist</h1>
                    <p style={style.p}>Simplify your finances. <span style={style.label}>Early beta</span></p>
                </div>
                <WelcomeForm
                    onLogin={this.onLogin.bind(this)}
                    onRegister={this.onRegister.bind(this)}
                    loginAttempts={this.props.loginAttempts}
                />
                <p style={style.disclaimer}>Thanks for trying the Moneylist early beta.</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Welcome.js